export const POLICIES = {
  // BASIC
  DESPOTISM: 'despotism',
  MILITARISM: 'militarism',
  INDUSTRIALISM: 'industrialism',
  PATRIOTISM: 'patriotism',
  OLIGARCHY: 'oligarchy',
  HEGEMONISM: 'hegemonism',
  BARBARISM: 'barbarism',
  TOTALITARIANISM: 'totalitarianism',
  SERVARIANISM: 'servarianism',
  FORTIFICATIONISM: 'fortificationism',
  ECOANARCHISM: 'ecoanarchism',
  THEOCRACY: 'theocracy',
  FANATICISM: 'fanaticism',
  AGRARIANISM: 'agrarianism',
  ISOLATIONISM: 'isolationism',
  // ADVANCED
  DEMOCRACY: 'democracy',
  PACIFISM: 'pacifism',
  LIBERALISM: 'liberalism',
  CONSERVATISM: 'conservatism',
  EXPANSIONISM: 'expansionism',
  NOMADISM: 'nomadism',
  MERCANTILISM: 'mercantilism',
  MERITOCRACY: 'meritocracy',
  DIPLOMATISM: 'diplomatism',
  SECTARIANISM: 'sectarianism',
  TECHNOCRACY: 'technocracy'
}